import script from "./promotionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionCard.vue?vue&type=script&setup=true&lang=ts"

import "./promotionCard.vue?vue&type=style&index=0&id=de629416&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de629416"]])

export default __exports__